import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import { LazyLoadImage } from "react-lazy-load-image-component";
import Img from "../../../images/locationgcc/sa/custom-software/we_deliver.webp";

function Banner(props) {
  return (
    <div className="experienced p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto">
            <h2>
              We Deliver User-Centric Software Solutions to Add Value to Your
              Business
            </h2>
            <p>
              We are committed to building custom software based on a
              client-centric approach that adds true value to your company.
              TekRevol’s custom software development solutions are designed to
              provide you with the support you need to establish a future-proof
              digital presence.
            </p>
            <p>
              Our process starts with a precise understanding of your business
              requirements and challenges, focusing on the desired outcomes.
              We're experts in handling complex software development projects,
              ensuring flawless execution, and delivering innovative solutions
              that meet the highest industry standards.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
            >
              Let’s Connect!
            </Link>
          </Col>
          <Col xs={12} md={6} lg={7} xl={7} xxl={7} className="my-auto">
            <LazyLoadImage
              src={Img}
              effect="blur"
              alt="Image"
              className="img-fluid"
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
